export default {
  afterCreated () {
    this.$toast.success('Visitante incluido com sucesso.')
    return this.$router.push({name: 'dweller.visitor.index'})
  },
  afterUpdated () {
    this.$toast.success('Visitante alterado com sucesso.')
    return this.$router.push({name: 'dweller.visitor.index'})
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/visitor/form/resources/methods.js